import { useEffect, useRef } from 'react';
import { useKeycloak } from 'Context/keyCloakProvider';
import {
  COURSE_IFRAME_CLOSE_EVENT,
  ensureKeycloakSession,
  isMoodleSessionTimeoutMessage,
} from 'utils/moodleSingleLogout';

export const useMoodleCourseIframeGuard = (closeCourseInline) => {
  const { keycloak } = useKeycloak();
  const closeRef = useRef(closeCourseInline);
  closeRef.current = closeCourseInline;

  useEffect(() => {
    const closeIframe = () => {
      if (typeof closeRef.current === 'function') {
        closeRef.current();
      }
    };

    const onCloseEvent = () => closeIframe();

    const onMessage = (event) => {
      if (!isMoodleSessionTimeoutMessage(event)) {
        return;
      }
      closeIframe();
      ensureKeycloakSession(keycloak);
    };

    window.addEventListener(COURSE_IFRAME_CLOSE_EVENT, onCloseEvent);
    window.addEventListener('message', onMessage);

    return () => {
      window.removeEventListener(COURSE_IFRAME_CLOSE_EVENT, onCloseEvent);
      window.removeEventListener('message', onMessage);
    };
  }, [keycloak]);
};
